import "core-js/modules/es.array.includes.js";
import icon from '@/assets/icon.png';
import wechatjt from '@/assets/wechatjt.png';
import android from '@/assets/android.png';
import one from '@/assets/show-one.png';
import two from '@/assets/show-two.png';
import three from '@/assets/show-three.png';
import safe from '@/assets/safe.png';
import mores from '@/assets/mores.png';
import down_back from '@/assets/invite/down_back.png';
import safari from '@/assets/safari.png';
import liulan from '@/assets/invite/liulan.png';
import share_point from '@/assets/invite/share_point.png';
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  name: 'DownPage',

  setup() {
    document.getElementById('viewport').content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;';
    const route = useRoute();
    const router = useRouter();
    const isWechat = ref(false);
    const show = ref(false);
    const isIos = ref(false);
    const userAgent = navigator.userAgent.toLowerCase();
    const match = userAgent.match(/MicroMessenger/i);

    if (match !== null && match.toString() === 'micromessenger') {
      isWechat.value = true;
    }

    isIos.value = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    const close = () => {
      show.value = false;
    }; //下载按钮点击时调用方法


    const down = () => {
      if (isWechat.value) {
        show.value = true;
      } else {
        if (isIos.value) {
          window.location.href = 'https://www.xqse.cn/h5';
        } else {
          if (route.params.code !== undefined && route.params.code !== '') {
            window.location.href = 'https://api.xqse.cn/web-api/index/download/' + route.params.code;
          } else {
            window.location.href = 'https://www.xqse.cn/download/androidRelease.apk';
          }
        }
      }
    };

    const toIos = () => {
      if (isWechat.value) {
        show.value = true;
      } else {
        down();
      }
    };

    const openIos = () => {
      if (isWechat.value) {
        show.value = true;
      } else {
        window.open('https://apps.apple.com/cn/app/ai%E5%B0%8F%E5%9C%88-%E6%99%BA%E8%83%BD%E5%A9%9A%E6%81%8B%E5%8C%B9%E9%85%8D%E6%83%85%E6%84%9F%E5%80%BE%E8%AF%89/id6748523962');
      }
    };

    onMounted(() => {
      const u = navigator.userAgent;
      const isAndroid = userAgent.indexOf('android') > -1 || u.indexOf('adr') > -1; //android终端
      // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端

      const isHarmony = userAgent.toLowerCase().includes('harmony'); //鸿蒙终端

      if (!isWechat.value && !isAndroid && !isIos.value && !isHarmony) {
        router.push({
          name: 'Home'
        });
      } // if (isIOS) {
      //   window.location.href = 'https://www.xqse.cn/ios/' + route.params.code ?? ''
      // }

    });
    return {
      icon,
      down,
      wechatjt,
      isWechat,
      show,
      android,
      safe,
      mores,
      down_back,
      safari,
      isIos,
      close,
      liulan,
      share_point,
      one,
      two,
      three,
      toIos,
      openIos
    };
  }

};